import { WorkModeEnum } from 'types/api.types.generated.d';

export enum WorkTypeEnum {
  Office = 'Office',
  Remote = 'Remote',
  Hybrid = 'Hybrid',
}

export const mapDtoToWorkTypeEnum = (dto: WorkModeEnum): WorkTypeEnum => {
  switch (dto) {
    case WorkModeEnum.Hybrid:
      return WorkTypeEnum.Hybrid;
    case WorkModeEnum.Remote:
      return WorkTypeEnum.Remote;
    case WorkModeEnum.Office:
      return WorkTypeEnum.Office;
    default:
      throw new Error(`Unhandled status: ${dto}`);
  }
};
